"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProductColor = exports.productColors = void 0;
const enums_1 = require("../enums");
exports.productColors = [
    { label: 'Lime', value: enums_1.Colors.lime, color: enums_1.Colors.lime },
    { label: 'Light Green', value: enums_1.Colors.lime, color: enums_1.Colors.lime },
    { label: 'Green', value: enums_1.Colors.green, color: enums_1.Colors.green },
    { label: 'Teal', value: enums_1.Colors.teal, color: enums_1.Colors.teal },
    { label: 'Yellow', value: enums_1.Colors.yellow, color: enums_1.Colors.yellow },
    { label: 'Amber', value: enums_1.Colors.amber, color: enums_1.Colors.amber },
    { label: 'Orange', value: enums_1.Colors.orange, color: enums_1.Colors.orange },
    { label: 'Deep Orange', value: enums_1.Colors.deepOrange, color: enums_1.Colors.deepOrange },
    { label: 'Red', value: enums_1.Colors.red, color: enums_1.Colors.red },
    { label: 'Pink', value: enums_1.Colors.pink, color: enums_1.Colors.pink },
    { label: 'Purple', value: enums_1.Colors.purple, color: enums_1.Colors.purple },
    { label: 'Deep Purple', value: enums_1.Colors.deepPurple, color: enums_1.Colors.deepPurple },
    { label: 'Indigo', value: enums_1.Colors.indigo, color: enums_1.Colors.indigo },
    { label: 'Light Blue', value: enums_1.Colors.lightBlue, color: enums_1.Colors.lightBlue },
    { label: 'Blue', value: enums_1.Colors.blue, color: enums_1.Colors.blue },
    { label: 'Brown', value: enums_1.Colors.brown, color: enums_1.Colors.brown },
    { label: 'Brown Dark', value: enums_1.Colors.brownDark, color: enums_1.Colors.brownDark },
    { label: 'Brown Light', value: enums_1.Colors.brownLight, color: enums_1.Colors.brownLight },
];
exports.defaultProductColor = enums_1.Colors.deepPurple;
//# sourceMappingURL=colors.js.map